import React from 'react';
import PropTypes from 'prop-types';
import Icon from './Icon';

export default class DocumentFile extends Icon {
  gradientId = this.getRandomId();

  icon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
    >
      <defs>
        <linearGradient
          id={this.gradientId}
          x1="97.859%"
          x2=".874%"
          y1="2.141%"
          y2="99.126%"
        >
          <stop offset="0%" stopColor="#00BD86" />
          <stop offset="100%" stopColor="#00A668" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd" opacity={this.props.opacity}>
        <rect width="40" height="40" fill={`url(#${this.gradientId})`} rx="5" />
        <rect width="12" height="12" x="5" y="5" fill="#FFF" rx="2" />
        <rect width="30" height="3" x="5" y="20" fill="#FFF" rx="1.5" />
        <rect width="7" height="3" x="20" y="8" fill="#FFF" rx="1.5" />
        <rect width="15" height="3" x="20" y="14" fill="#FFF" rx="1.5" />
        <rect width="30" height="3" x="5" y="26" fill="#FFF" rx="1.5" />
        <rect width="30" height="3" x="5" y="32" fill="#FFF" rx="1.5" />
      </g>
    </svg>
  );
}

DocumentFile.defaultProps = {
  opacity: '1.0',
};

DocumentFile.propTypes = {
  opacity: PropTypes.string,
};
